import axios from 'axios';
import store from '../store/store'

export default {
    async execute(method, resource, data) {
        // inject the accessToken for each request
        await store.getters.getPropertyGuid
        await store.getters.getTenantGuid
        await store.getters.getJwtAuthenticationToken
        return axios({
            method,
            data,
            headers: {
                Authorization: store.getters.getJwtAuthenticationToken //the token is a variable which holds the token
            },
            url: "/residents/properties/" + store.getters.getPropertyGuid +
                '/units/users/' + resource,
        }).then(async req => {
            return req.data
        })
    },
    async updateDevice(userId, deviceGuid, device){
        let resource = userId + "/devices/" + deviceGuid;
        return this.execute("patch", resource, device);
    },
    async deleteDevice(userId, deviceGuid){
        return this.execute("delete", userId+"/devices/"+deviceGuid);
    }

}
